<script setup lang="ts">
import UserFeatureToggle from "../users/UserFeatureToggle.vue";

const dashboard = defineModel<boolean>("dashboard", { required: true });
const integrity = defineModel<boolean>("integrity", { required: true });
const report = defineModel<boolean>("report", { required: true });
const audit = defineModel<boolean>("audit", { required: true });
</script>

<template>
	<div>
		<UserFeatureToggle v-model="dashboard" feature="dashboard" />
		<UserFeatureToggle v-model="integrity" feature="integrity" />
		<UserFeatureToggle v-model="report" feature="report" />
		<UserFeatureToggle v-model="audit" feature="audit" />
	</div>
</template>
